package dev.kuml.portal.web.i18n.strings

/** Cross-cutting copy shared by several screens (popover buttons, generic network-error text,
 * the bilingual language-switcher group label). Domain-specific copy stays in its own
 * `*Strings` interface even when the words happen to coincide (see e.g. `AuthStrings.submitLogin`
 * vs. `AuthStrings.loginTab`) -- this interface is only for text that is GENUINELY reused verbatim
 * across unrelated screens. */
public interface CommonStrings {
    public val cancel: String
    public val delete: String
    public val save: String
    public val retry: String
    public val loading: String
    public val networkErrorReload: String
    public val networkErrorRetry: String

    /** `role="group"`'s `aria-label` on [dev.kuml.portal.web.components.languageSwitcher] --
     * deliberately IDENTICAL in both languages (bilingual on purpose, see that function's KDoc):
     * this is the one control that must be identifiable before the reader knows which language
     * they are in. */
    public val languageSwitcherAriaLabel: String get() = "Sprache / Language"

    public val allPlainStrings: List<String>
        get() = listOf(cancel, delete, save, retry, loading, networkErrorReload, networkErrorRetry)
}

public object CommonStringsDe : CommonStrings {
    override val cancel = "Abbrechen"
    override val delete = "Löschen"
    override val save = "Speichern"
    override val retry = "Erneut versuchen"
    override val loading = "Wird geladen …"
    override val networkErrorReload = "Verbindung fehlgeschlagen. Bitte laden Sie die Seite neu."
    override val networkErrorRetry = "Verbindung fehlgeschlagen. Bitte erneut versuchen."
}

public object CommonStringsEn : CommonStrings {
    override val cancel = "Cancel"
    override val delete = "Delete"
    override val save = "Save"
    override val retry = "Retry"
    override val loading = "Loading …"
    override val networkErrorReload = "Connection failed. Please reload the page."
    override val networkErrorRetry = "Connection failed. Please try again."
}
